import {getUserConfig} from "@utility/utils";

const initialState = {
    list: [],
    total: 0,
    loading: false,
    searching: false,
    searchParams: {
        player_user_id: "",
        event_types: "-1,1010000,1020000,1030000,2010100,2020100,2030100,9010000,combine1,9050000",
        related_gameIDs: "-1",
        start_date: new Date(),
        end_date: new Date(),
        page: 1,
        count: 30,
        refresh: false,
        ...getUserConfig("playerCoinRecord")
    }
}

const coinRecord = (state = initialState, action) => {
    switch (action.type) {
        case 'PLAYER_COIN_RECORD':
            return {
                ...state,
                ...action.payload
            }
        case 'PLAYER_COIN_RECORD_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams, ...getUserConfig("playerCoinRecord")
                },
            }
        default:
            return {...state};
    }
}

export default coinRecord
